import EntityType from '@enums/EntityType';

export default function isEntitySkill(entityType) {
  if (
    entityType === EntityType.ROLE_SKILL ||
    entityType === EntityType.PERSON_SKILL
  ) {
    return true;
  }
}
